"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = __importDefault(require("styled-components"));
var InputIcon = (0, styled_components_1.default)('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  left: -30px;\n  top: 35px;\n  background: url(", ") no-repeat 50%;\n"], ["\n  display: block;\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  left: -30px;\n  top: 35px;\n  background: url(", ") no-repeat 50%;\n"])), function (props) { return props.url; });
exports.default = InputIcon;
var templateObject_1;
//# sourceMappingURL=InputIcon.js.map